import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import CumaModal from './CumaModal';
import CumaModalContents from './CumaModalContents';
import { useAppSelector } from 'src/hooks/hooks';

const ProgressBox = styled.div`
    font-size: 30px;
    font-weight: bold;
    display: block;
    width: 300px;
    height: 300px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    position: absolute;
    color: #000;
    outline: none;
`;

interface Props {
    progress: number;
}

function ProgressBar({ progress }: Props) {
    const progressValue = useAppSelector(state => state.progress.progress);
    const [open, setOpen] = useState<boolean>(false);

    useEffect(() => {
        if (0 < progress && progress < 100) {
            setOpen(true);
        } else {
            setOpen(false);
        }
    }, [progress]);

    useEffect(() => {
        if (0 < progressValue && progressValue < 100) {
            setOpen(true);
        } else {
            setOpen(false);
        }
    }, [progressValue]);

    return (
        <>
            {open && (
                <CumaModal>
                    <CumaModalContents
                        modalStyleType={{
                            type: 'onlyText',
                            contents: `등록중입니다.. ${progress}%`,
                        }}
                    />
                </CumaModal>
            )}
        </>
    );
}

export default ProgressBar;
